<template>
  <EmptySubscriptionPage
    v-if="!hasFeatureFlag('module-products')"
    :text="{
      title: $t('upgrade_subscription_page.products.suppliers.title'),
      description: $t(
        'upgrade_subscription_page.products.suppliers.description'
      ),
      btnPrimary: $t('upgrade_subscription_page.upgrade_btn')
    }"
    imageName="products"
  />
  <Flex
    direction="column"
    v-else
  >
    <Page
      :query="GET_SUPPLIERS"
      :multiLocation="true"
      :actions="{
        text: 'global.actions.create_supplier',
        route: 'create-supplier',
      }"
      :emptyPageContent="{
        route: 'create-supplier',
        title: $t('products.empty_state.suppliers.title'),
        description: $t('products.empty_state.suppliers.description'),
        btnPrimary: $t('global.actions.create_supplier'),
        imageName: 'products',
      }"
    >
      <SuppliersList />
    </Page>
  </Flex>
</template>

<script
  setup
  lang="ts"
>
import EmptySubscriptionPage from '@/modules/_shared/subscription/EmptySubscriptionPage.vue';
import { useUserStore } from '@/stores/user';
import Page from '../_shared/Page.vue';
import { GET_SUPPLIERS } from './graphql';
import SuppliersList from './SuppliersList.vue';

const { hasFeatureFlag } = useUserStore();
</script>
